/**
 * Created by tmorone on 1/26/2016.
 */

var $ = global.$ = jQuery = require('jquery');
require('bootstrap');
require('./helpers/swf.js');
require('./helpers/purchase-stripe.js');
require('./helpers/purchase-paypal.js');
require('./helpers/mixpanel.js');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Router = require('./router');
var Logger = require('./helpers/logger.js');
var User = require('./models/UserModel.js');
var Facebook = require('./helpers/facebook.js');
var Analytics = require('./helpers/google-analytics.js');

/**
 * Only added for Marionette tool to work in Chrome developer tool.
 */
if (window.__agent) {
    window.__agent.start(Backbone, Marionette);
}

/**
 * Strip the hash code appended by facebook callback
 */
if (window.location.hash && window.location.hash == '#_=_') {
    window.location.hash = '';
}

/**
 * The entry point of the portal application.
 * The appropriate view is loaded as determined by the router.
 */
var App = exports.App = new Marionette.Application({
    onStart: function (options) {
        this.config = options.config;
        Backbone.history.start({pushState:true});
    }
});

var logger = exports.Logger = new Logger({mode: window.PR.environment});
var events = exports.Events = Backbone.Events;
exports.Config = window.PR;
exports.User = global.User = new User(PR.user ? JSON.parse(PR.user) : {});

exports.Analytics = global.Analytics = new Analytics();
exports.Router = new Router();
exports.Facebook = new Facebook();

global.gameInstance = {};

global.logout = function() {
    window.location.assign('/logout');
};

$(document).ready(function() {
    App.start({config: {}});
    logger.info("Application Started");
});
